export default "__VITE_ASSET__Bmz6OEIa__"